import { jsx } from "panel";
import { InputEl } from "common/components/input";
import { InputSize, InputType, TextAlign, ValidationStatus } from "common/components/input/types";
import { ButtonEl } from "common/components/button";
import { ButtonSize, ButtonTheme } from "common/components/button/constants";
import { TimeUnit } from "common/widgets/date-range-picker/models/types";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
import { SelectEl } from "common/components/select";
import { MinMultiAttributionLookbackDays } from "./constants";
export function template() {
  const invalidLookbackDaysText = this.getInvalidLookbackDaysText();
  return /* @__PURE__ */ jsx("div", {
    attrs: {
      elRef: `multiAttributionLookbackContent`
    },
    sel: ".multi-attribution-lookback-content"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".multi-attribution-lookback-title"
  }, "Lookback Window", /* @__PURE__ */ jsx("div", {
    sel: ".multi-attribution-lookback-info-container"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `info` }
  }), /* @__PURE__ */ jsx(TooltipEl, {
    attrs: { "max-width": `250px` }
  }, "The time window where a user's events with this attribution property are counted towards the calculation. The window ends when the conversion metric happens."))), /* @__PURE__ */ jsx("div", {
    sel: ".multi-attribution-lookback-body"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".multi-attribution-lookback-window-section"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".multi-attribution-lookback-value-container"
  }, /* @__PURE__ */ jsx(InputEl, {
    sel: ".multi-attribution-lookback-value-input",
    attrs: {
      elref: `multiAttributionLookbackValueInput`,
      disabled: this.state.stagedLookbackUnit === TimeUnit.Session,
      size: InputSize.Large,
      type: InputType.Number,
      min: MinMultiAttributionLookbackDays.toString(),
      max: this.getMaxLookbackDays().toString(),
      "text-align": TextAlign.Center,
      "validation-status": invalidLookbackDaysText ? ValidationStatus.Invalid : ValidationStatus.Default
    },
    on: { input: (ev) => this.handleLookbackValueInput(ev) },
    props: {
      value: this.state.stagedLookbackValue
    }
  }), this.state.stagedLookbackUnit === TimeUnit.Session && /* @__PURE__ */ jsx(TooltipEl, {
    attrs: {
      text: `Sessions is currently limited to 1`
    }
  })), /* @__PURE__ */ jsx(SelectEl, {
    sel: ".multi-attribution-lookback-unit",
    attrs: {
      elref: `multiAttributionLookbackUnit`,
      sections: this.getLookbackUnitSections(),
      "menu-width": null,
      size: ButtonSize.Large
    },
    on: {
      change: (ev) => this.handleChangeLookbackUnit(ev)
    }
  })), invalidLookbackDaysText && /* @__PURE__ */ jsx("div", {
    sel: ".multi-attribution-lookback-error",
    attrs: {
      elref: `multiAttributionLookbackError`
    }
  }, invalidLookbackDaysText)), /* @__PURE__ */ jsx("div", {
    sel: ".multi-attribution-lookback-footer"
  }, /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".multi-attribution-lookback-reset-button",
    attrs: {
      elref: `multiAttributionLookbackResetButton`,
      disabled: this.isDefaultLookbackWindow(),
      theme: ButtonTheme.Tertiary
    },
    on: { click: () => this.handleClickReset() }
  }, "Reset"), /* @__PURE__ */ jsx("div", {
    sel: ".multi-attribution-lookback-core-buttons"
  }, /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".multi-attribution-lookback-cancel-button",
    attrs: {
      theme: ButtonTheme.Tertiary
    },
    on: { click: () => this.dispatchCancel() }
  }, "Cancel"), /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".multi-attribution-lookback-apply-button",
    attrs: {
      elref: `multiAttributionLookbackApplyButton`,
      disabled: Boolean(invalidLookbackDaysText),
      theme: ButtonTheme.Primary
    },
    on: { click: () => this.dispatchChange() }
  }, "Apply"))));
}
